import OcrListing from './ocrListing';

const PurchaseListingNewButton = [{
    label: window.i18n.__('Créer une facture fournisseur'),
    primary: true,
    disabled: true,
    databot: 'purchases-purinvoices-list_create-invoice',
    items: [
        {
            label: window.i18n.__('Créer une facture'),
            icon: 'plus',
            href: 'javascript:DocTools.createForThird("purInvoice", "' + window.i18n.__('Créer une facture fournisseur') + '")',
            permission: 'create',
            databot: 'purchases-purinvoices-list_create-invoice_docform',
        },{
            label: window.i18n.__('Saisie rapide'),
            icon: 'edit',
            href: '/?_f=purchases_fastpurchase&action=loadForm',
            permission: ['create','create_fast'],
            databot: 'purchases-purinvoices-list_create-invoice_fast',
        },{
            label: window.i18n.__('Importer une facture'),
            icon: 'download',
            type: 'function',                        
            url: {
                event: 'openPurchaseInvoiceModal',
            },
            permission: 'import',
            databot: 'purchases-purinvoices-list_import-invoice',
        }
    ],
}];
const PurchaseListing = [
    {
        ...OcrListing[0],
        group: 'purchase',
    },
    {
        id: 'purchaseinvoices',
        label: window.i18n.__('Factures traitées'),
        buttons: [
            ...PurchaseListingNewButton
        ],
        linkedtype: 'purInvoice',
        name: 'purchaseinvoices',
        group: 'purchase',
    }
];
PurchaseListing[0].buttons.push(...PurchaseListingNewButton);
export default PurchaseListing;
